import React from 'react';
import Icon from '../../../components/AppIcon';

const TrendingTopics = () => {
  const trendingTopics = [
    {
      hashtag: '#FestivalTechno2024',
      posts: '1.2k publications',
      trend: 'up',
      category: 'Événements'
    },
    {
      hashtag: '#CollaborationMusicale',
      posts: '856 publications',
      trend: 'up',
      category: 'Collaborations'
    },
    {
      hashtag: '#ProductionElectronique',
      posts: '634 publications',
      trend: 'stable',
      category: 'Formation'
    },
    {
      hashtag: '#MixtapeFriday',
      posts: '423 publications',
      trend: 'up',
      category: 'Musique'
    },
    {
      hashtag: '#IndustryNews',
      posts: '298 publications',
      trend: 'down',
      category: 'Actualités'
    }
  ];

  const getTrendIcon = (trend) => {
    switch (trend) {
      case 'up': return { icon: 'TrendingUp', color: 'text-green-500' };
      case 'down': return { icon: 'TrendingDown', color: 'text-red-500' };
      default: return { icon: 'Minus', color: 'text-muted-foreground' };
    }
  };

  return (
    <div className="bg-surface rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Tendances</h3>
        <Icon name="Hash" size={20} className="text-muted-foreground" />
      </div>

      <div className="space-y-4">
        {trendingTopics?.map((topic, index) => {
          const trendInfo = getTrendIcon(topic?.trend);
          return (
            <div
              key={index}
              className="group cursor-pointer hover:bg-muted rounded-lg p-3 transition-colors -mx-3"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center space-x-2 mb-1">
                    <h4 className="font-semibold text-foreground group-hover:text-accent transition-colors">
                      {topic?.hashtag}
                    </h4>
                    <Icon 
                      name={trendInfo?.icon} 
                      size={14} 
                      className={trendInfo?.color}
                    />
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {topic?.posts}
                  </div>
                  <div className="text-xs text-muted-foreground mt-1">
                    {topic?.category}
                  </div>
                </div>
                <div className="text-xs text-muted-foreground text-right">
                  #{index + 1}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 pt-4 border-t border-border">
        <button className="text-sm text-accent hover:text-accent/80 transition-colors font-medium">
          Voir plus de tendances
        </button>
      </div>
    </div>
  );
};

export default TrendingTopics;